export function getRowMetadata(props) {
    let isRowLoading = false;
    let isRowReadOnly = false;
    const { getIsRowLoading, getIsRowReadOnly, row } = props;
    if (getIsRowLoading) {
        if (row.isGrouped) {
            isRowLoading = row.leafRows.some((r) => !getIsRowLoading(r.original)) ? false : true;
        }
        else {
            isRowLoading = getIsRowLoading(row.original);
        }
    }
    if (getIsRowReadOnly) {
        if (row.isGrouped) {
            isRowReadOnly = row.leafRows.some((r) => !getIsRowReadOnly(r.original)) ? false : true;
        }
        else {
            isRowReadOnly = getIsRowReadOnly(row.original);
        }
    }
    return { isRowLoading, isRowReadOnly };
}
